import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import PageFormLayout from './containers/Form'
import PagesGridLayout from './containers/Grid';

export default function PageLayout() {
  return <Router>
    <PrivateRoute exact path="/path/pages" component={PagesGridLayout} />
    <PrivateRoute path={["/path/pages/add", "/path/pages/:id"]} component={PageFormLayout} />
  </Router>
}
